// Third Party
import * as React from 'react';

// Utils
import { ota_info } from './utils';

// Components
import { LoadingSkeleton, ComparisonQuoteItem } from './components';
import { useQuoteComparison } from './quote-comparison-context';
import { AnalyticsRef } from '@components/analytics-ref';

export const QuotesCompare: React.FC = () => {
  const { comparisonQuotes, isLoading, showComparison, quoteUrls, afterTaxes } =
    useQuoteComparison();
  return (
    <AnalyticsRef name="price_comparison_tool">
      <div className="overflow-hidden max-h-screen rounded-lg bg-fog">
        <div className="py-5">
          {isLoading && <LoadingSkeleton />}
          {showComparison && !isLoading && (
            <div className="space-y-10 px-5">
              {comparisonQuotes.map((quote, index) => (
                <ComparisonQuoteItem
                  afterTaxes={afterTaxes}
                  key={index}
                  comparisonQuote={quote}
                  otaUrl={quoteUrls[quote.externalSource || '']}
                  otaInfo={ota_info}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </AnalyticsRef>
  );
};
